webpackJsonp([2,0],{

/***/ 0:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _vue = __webpack_require__(47);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _vueRouter = __webpack_require__(46);
	
	var _vueRouter2 = _interopRequireDefault(_vueRouter);
	
	var _store = __webpack_require__(19);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _router = __webpack_require__(17);
	
	var _router2 = _interopRequireDefault(_router);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	__webpack_require__(92);
	
	_vue2.default.use(_vueRouter2.default);
	
	new _vue2.default({
	  store: _store2.default,
	  router: _router2.default
	}).$mount('#app');

/***/ },

/***/ 17:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vueRouter = __webpack_require__(46);
	
	var _vueRouter2 = _interopRequireDefault(_vueRouter);
	
	var _store = __webpack_require__(19);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _App = __webpack_require__(111);
	
	var _App2 = _interopRequireDefault(_App);
	
	var _Auth = __webpack_require__(112);
	
	var _Auth2 = _interopRequireDefault(_Auth);
	
	var _actions = __webpack_require__(18);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var router = new _vueRouter2.default({
	  mode: 'history',
	  routes: [{ path: '/', component: _Auth2.default }, { path: '/app', component: _App2.default, beforeEnter: function beforeEnter(to, from, next) {
	      (0, _actions.authUser)(next('/')).then(function () {
	        next();
	      });
	    } }]
	});
	
	exports.default = router;

/***/ },

/***/ 18:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.checkAuth = exports.authUser = exports.logOut = exports.deleteNote = exports.toggleFavourite = exports.addNote = exports.toggleFavouriteView = exports.updateActiveNote = exports.editNote = undefined;
	
	var _promise = __webpack_require__(56);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	var _store = __webpack_require__(19);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _firebaseConfig = __webpack_require__(29);
	
	var _firebase = __webpack_require__(9);
	
	var _firebase2 = _interopRequireDefault(_firebase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var editNote = exports.editNote = function editNote(context, e) {
	  var notesRef = (0, _firebaseConfig.getRef)('users/' + _store2.default.getters.userId + '/notes');
	  var updatedNote = {
	    text: e.target.value,
	    favourite: context.getters.activeNote.favourite
	  };
	  notesRef.child(context.getters.activeNote['.key']).update(updatedNote).then(context.commit('FIND_ACTIVE_NOTE', context.getters.activeNote['.key']));
	};
	
	var updateActiveNote = exports.updateActiveNote = function updateActiveNote(_ref, note) {
	  var commit = _ref.commit;
	
	  commit('SET_ACTIVE_NOTE', note);
	};
	
	var toggleFavouriteView = exports.toggleFavouriteView = function toggleFavouriteView(_ref2) {
	  var commit = _ref2.commit;
	
	  commit('TOGGLE_FAVOURITE_VIEW');
	};
	
	var addNote = exports.addNote = function addNote(context) {
	  var notesRef = (0, _firebaseConfig.getRef)('users/' + _store2.default.getters.userId + '/notes');
	  var changeState = function changeState() {
	    if (context.getters.displayingFavourites) {
	      context.commit('TOGGLE_FAVOURITE_VIEW');
	    }
	  };
	
	  var newNote = {
	    text: '✍ ...',
	    favourite: false
	  };
	
	  var error = function error() {
	    return console.log('Error adding note');
	  };
	
	  notesRef.push(newNote).then(changeState, error);
	};
	
	var toggleFavourite = exports.toggleFavourite = function toggleFavourite(context) {
	  var notesRef = (0, _firebaseConfig.getRef)('users/' + _store2.default.getters.userId + '/notes');
	  if (context.getters.isCurrentActiveAccessible) {
	    var updatedNote = {
	      text: context.getters.activeNote.text,
	      favourite: !context.getters.activeNote.favourite
	    };
	    notesRef.child(context.getters.activeNote['.key']).update(updatedNote).then(context.commit('FIND_ACTIVE_NOTE', context.getters.activeNote['.key']));
	  }
	};
	
	var deleteNote = exports.deleteNote = function deleteNote(context) {
	  var notesRef = (0, _firebaseConfig.getRef)('users/' + _store2.default.getters.userId + '/notes');
	  var key = context.getters.activeNote['.key'];
	  var index = context.state.notes.indexOf(context.getters.activeNote) - 1;
	  if (index < 0) {
	    index = 0;
	  }
	  notesRef.child(key).remove().then(context.state.activeNote = context.state.notes[index]);
	};
	
	var logOut = exports.logOut = function logOut(context) {
	  _firebase2.default.auth().signOut().then(function () {
	    window.location.reload();
	  }, function (error) {
	    console.log(error);
	    window.location.reload();
	  });
	};
	
	var authUser = exports.authUser = function authUser(onFail, onSuccess) {
	  return new _promise2.default(function (resolve, reject) {
	    _firebase2.default.auth().onAuthStateChanged(function (user) {
	      if (checkAuth) {
	        _store2.default.commit('SET_USER', user);
	      } else {
	        _store2.default.commit('RESET_USER', user);
	        onFail();
	      }
	      resolve(user);
	    }, function (error) {
	      console.log(error);
	    });
	  });
	};
	
	var checkAuth = exports.checkAuth = function checkAuth() {
	  return user != null || _store2.default.getters.user;
	};

/***/ },

/***/ 19:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends2 = __webpack_require__(10);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _vue = __webpack_require__(47);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _vuex = __webpack_require__(16);
	
	var _vuex2 = _interopRequireDefault(_vuex);
	
	var _vuexfire = __webpack_require__(121);
	
	var _vuexfire2 = _interopRequireDefault(_vuexfire);
	
	var _actions = __webpack_require__(18);
	
	var actions = _interopRequireWildcard(_actions);
	
	var _getters = __webpack_require__(53);
	
	var getters = _interopRequireWildcard(_getters);
	
	var _mutations = __webpack_require__(54);
	
	var mutations = _interopRequireWildcard(_mutations);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_vue2.default.use(_vuex2.default);
	_vue2.default.use(_vuexfire2.default);
	
	var state = {
	    notes: null,
	    activeNote: null,
	    displayingFavourites: false,
	    user: null
	};
	
	exports.default = new _vuex2.default.Store({
	    state: state,
	    mutations: (0, _extends3.default)({}, _vuexfire2.default.mutations, mutations),
	    getters: getters,
	    actions: actions
	});

/***/ },

/***/ 29:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getRef = undefined;
	
	var _firebase = __webpack_require__(9);
	
	var _firebase2 = _interopRequireDefault(_firebase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var config = {
	  apiKey: "AIzaSyD0atCD0tCK8Wqp26Hs5rbaNZW7FtcZp7U",
	  authDomain: "generic-notes.firebaseapp.com",
	  databaseURL: "https://generic-notes.firebaseio.com",
	  storageBucket: "generic-notes.appspot.com",
	  messagingSenderId: "674872281364"
	};
	
	var firebaseApp = _firebase2.default.initializeApp(config);
	var db = firebaseApp.database();
	
	var getRef = exports.getRef = function getRef(path) {
	  return db.ref(path);
	};
	
	exports.default = { db: db, getRef: getRef };

/***/ },

/***/ 48:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Toolbar = __webpack_require__(115);
	
	var _Toolbar2 = _interopRequireDefault(_Toolbar);
	
	var _NotesList = __webpack_require__(114);
	
	var _NotesList2 = _interopRequireDefault(_NotesList);
	
	var _Editor = __webpack_require__(113);
	
	var _Editor2 = _interopRequireDefault(_Editor);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: {
	    Toolbar: _Toolbar2.default,
	    NotesList: _NotesList2.default,
	    Editor: _Editor2.default
	  }
	};

/***/ },

/***/ 49:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _firebase = __webpack_require__(9);
	
	var _firebase2 = _interopRequireDefault(_firebase);
	
	var _firebaseui = __webpack_require__(101);
	
	var _firebaseui2 = _interopRequireDefault(_firebaseui);
	
	var _router = __webpack_require__(17);
	
	var _router2 = _interopRequireDefault(_router);
	
	var _actions = __webpack_require__(18);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var uiConfig = {
	  signInOptions: [_firebase2.default.auth.GoogleAuthProvider.PROVIDER_ID, _firebase2.default.auth.GithubAuthProvider.PROVIDER_ID, _firebase2.default.auth.EmailAuthProvider.PROVIDER_ID],
	  tosUrl: '/tos',
	  callbacks: {
	    signInSuccess: function signInSuccess(currentUser, credential, redirectUrl) {
	      _router2.default.push('/app');
	      return false;
	    }
	  }
	
	};
	
	exports.default = {
	  name: 'auth',
	  beforeMount: function beforeMount() {
	    this.ui = new _firebaseui2.default.auth.AuthUI(_firebase2.default.auth());
	    (0, _actions.authUser)(this.ui.start('#firebaseui-auth-container', uiConfig));
	  }
	};

/***/ },

/***/ 50:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends2 = __webpack_require__(10);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _vuex = __webpack_require__(16);
	
	var _debounce = __webpack_require__(106);
	
	var _debounce2 = _interopRequireDefault(_debounce);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	    methods: (0, _extends3.default)({}, (0, _vuex.mapActions)(['editNote', 'addNote']), {
	        updateNote: (0, _debounce2.default)(function (event) {
	            if (this.$store.state.notes.length === 0) {
	                this.addNote();
	            }
	            this.editNote(event);
	        }, 150)
	    }),
	    computed: {
	        activeNote: function activeNote() {
	            return this.$store.state.activeNote == undefined ? { text: 'Why not start typing?' } : this.$store.state.activeNote;
	        },
	        isActiveNote: function isActiveNote() {
	            return !(this.$store.state.activeNote == undefined);
	        }
	    }
	};

/***/ },

/***/ 51:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends2 = __webpack_require__(10);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _vuex = __webpack_require__(16);
	
	var _firebaseConfig = __webpack_require__(29);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	    methods: (0, _vuex.mapActions)(['updateActiveNote', 'toggleFavouriteView']),
	    computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)(['favouriteNotes', 'activeNote', 'userId', 'displayingFavourites', 'notes'])),
	    created: function created() {
	        if (this.userId) {
	            this.$bindAsArray('notes', (0, _firebaseConfig.getRef)('users/' + this.userId + '/notes'));
	        }
	    }
	};

/***/ },

/***/ 52:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(10);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _vuex = __webpack_require__(16);
	
	var _firebase = __webpack_require__(9);
	
	var _firebase2 = _interopRequireDefault(_firebase);
	
	var _router = __webpack_require__(17);
	
	var _router2 = _interopRequireDefault(_router);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	
	  methods: (0, _extends3.default)({}, (0, _vuex.mapActions)(['deleteNote', 'deleteNote', 'signOut', 'addNote', 'toggleFavourite']), {
	    signOut: function signOut() {
	      _firebase2.default.auth().signOut().then(this.onSignOut, this.onError);
	    },
	    onSignOut: function onSignOut() {
	      console.log('onSignOut');
	      _router2.default.push({ path: '/', query: { ref: 'signout' } });
	    },
	    onError: function onError() {
	      console.error('onError');
	    }
	  }),
	  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)(['isCurrentFavourite', 'isCurrentActiveAccessible']))
	};

/***/ },

/***/ 53:
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var activeNote = exports.activeNote = function activeNote(state) {
	  return state.activeNote;
	};
	
	var displayingFavourites = exports.displayingFavourites = function displayingFavourites(state) {
	  return state.displayingFavourites;
	};
	
	var user = exports.user = function user(state) {
	  return state.user;
	};
	
	var userId = exports.userId = function userId(state) {
	  return state.user == null ? '' : state.user.uid;
	};
	
	var isCurrentFavourite = exports.isCurrentFavourite = function isCurrentFavourite(state) {
	  return state.activeNote != null && state.activeNote.favourite;
	};
	
	var isCurrentActiveAccessible = exports.isCurrentActiveAccessible = function isCurrentActiveAccessible(state) {
	  return state.activeNote != null && (state.displayingFavourites && state.activeNote.favourite || !state.displayingFavourites) && state.notes.length > 0;
	};
	
	var notes = exports.notes = function notes(state) {
	  return state.displayingFavourites ? state.notes.filter(function (note) {
	    return note.favourite;
	  }) : state.notes;
	};

/***/ },

/***/ 54:
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var SET_ACTIVE_NOTE = exports.SET_ACTIVE_NOTE = function SET_ACTIVE_NOTE(state, note) {
	  state.activeNote = note;
	};
	
	var FIND_ACTIVE_NOTE = exports.FIND_ACTIVE_NOTE = function FIND_ACTIVE_NOTE(state, key) {
	  var toBeActive = state.notes.find(function (note) {
	    return note['.key'] === key;
	  });
	  state.activeNote = toBeActive;
	};
	
	var TOGGLE_FAVOURITE_VIEW = exports.TOGGLE_FAVOURITE_VIEW = function TOGGLE_FAVOURITE_VIEW(state) {
	  state.displayingFavourites = !state.displayingFavourites;
	};
	
	var SET_USER = exports.SET_USER = function SET_USER(state, user) {
	  state.user = user;
	};
	
	var RESET_USER = exports.RESET_USER = function RESET_USER(state) {
	  state.user = null;
	};

/***/ },

/***/ 92:
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },

/***/ 93:
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },

/***/ 94:
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },

/***/ 95:
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },

/***/ 96:
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },

/***/ 111:
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(94)
	
	/* script */
	__vue_exports__ = __webpack_require__(48)
	
	/* template */
	var __vue_template__ = __webpack_require__(117)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ },

/***/ 112:
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(96)
	
	/* script */
	__vue_exports__ = __webpack_require__(49)
	
	/* template */
	var __vue_template__ = __webpack_require__(120)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ },

/***/ 113:
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(50)
	
	/* template */
	var __vue_template__ = __webpack_require__(119)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ },

/***/ 114:
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(93)
	
	/* script */
	__vue_exports__ = __webpack_require__(51)
	
	/* template */
	var __vue_template__ = __webpack_require__(116)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-0af3c2b0"
	
	module.exports = __vue_exports__


/***/ },

/***/ 115:
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(95)
	
	/* script */
	__vue_exports__ = __webpack_require__(52)
	
	/* template */
	var __vue_template__ = __webpack_require__(118)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-76abd76c"
	
	module.exports = __vue_exports__


/***/ },

/***/ 116:
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    attrs: {
	      "id": "notes-list"
	    }
	  }, [_c('div', {
	    attrs: {
	      "id": "list-header"
	    }
	  }, [_c('h2', [_vm._v("Notes")]), _vm._v(" "), _c('div', {
	    staticClass: "btn-group btn-group-justified",
	    attrs: {
	      "role": "group"
	    }
	  }, [_c('div', {
	    staticClass: "btn-group",
	    attrs: {
	      "role": "group"
	    }
	  }, [_c('button', {
	    staticClass: "btn btn-default",
	    class: {
	      active: !_vm.displayingFavourites
	    },
	    attrs: {
	      "type": "button"
	    },
	    on: {
	      "click": function($event) {
	        _vm.toggleFavouriteView()
	      }
	    }
	  }, [_vm._v("\n          All Notes\n        ")])]), _vm._v(" "), _c('div', {
	    staticClass: "btn-group",
	    attrs: {
	      "role": "group"
	    }
	  }, [_c('button', {
	    staticClass: "btn btn-default",
	    class: [{
	      active: _vm.displayingFavourites
	    }],
	    attrs: {
	      "type": "button"
	    },
	    on: {
	      "click": function($event) {
	        _vm.toggleFavouriteView()
	      }
	    }
	  }, [_vm._v("\n          Favorites\n        ")])])])]), _vm._v(" "), _c('div', {
	    staticClass: "container"
	  }, [_c('div', {
	    staticClass: "list-group"
	  }, _vm._l((_vm.notes), function(note) {
	    return _c('button', {
	      staticClass: "list-group-item",
	      class: {
	        active: _vm.activeNote === note
	      },
	      attrs: {
	        "href": "#"
	      },
	      on: {
	        "click": function($event) {
	          _vm.updateActiveNote(note)
	        }
	      }
	    }, [_c('h4', {
	      staticClass: "list-group-item-heading"
	    }, [(note.favourite) ? _c('i', {
	      staticClass: "glyphicon glyphicon-star star"
	    }) : _vm._e(), _vm._v("\n          " + _vm._s(note.text.trim().substring(0, 30)) + "\n        ")])])
	  }))])])
	},staticRenderFns: []}

/***/ },

/***/ 117:
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    attrs: {
	      "id": "app"
	    }
	  }, [_c('toolbar'), _vm._v(" "), _c('notes-list'), _vm._v(" "), _c('editor')], 1)
	},staticRenderFns: []}

/***/ },

/***/ 118:
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    attrs: {
	      "id": "toolbar"
	    }
	  }, [_c('i', {
	    staticClass: "glyphicon glyphicon-plus plus",
	    on: {
	      "click": function($event) {
	        _vm.addNote()
	      }
	    }
	  }), _vm._v(" "), _c('i', {
	    staticClass: "glyphicon glyphicon-star",
	    class: [{
	      starred: _vm.isCurrentFavourite
	    }, {
	      star: _vm.isCurrentActiveAccessible
	    }, {
	      disabled: !_vm.isCurrentActiveAccessible
	    }],
	    attrs: {
	      "disabled": _vm.isCurrentActiveAccessible ? false : true
	    },
	    on: {
	      "click": function($event) {
	        _vm.toggleFavourite()
	      }
	    }
	  }), _vm._v(" "), _c('i', {
	    staticClass: "glyphicon glyphicon-remove",
	    class: [{
	      remove: _vm.isCurrentActiveAccessible
	    }, {
	      disabled: !_vm.isCurrentActiveAccessible
	    }],
	    attrs: {
	      "disabled": _vm.isCurrentActiveAccessible ? false : true
	    },
	    on: {
	      "click": _vm.deleteNote
	    }
	  }), _vm._v(" "), _c('i', {
	    staticClass: "glyphicon glyphicon-off signOut bottom",
	    on: {
	      "click": _vm.signOut
	    }
	  })])
	},staticRenderFns: []}

/***/ },

/***/ 119:
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    attrs: {
	      "id": "note-editor"
	    }
	  }, [_c('textarea', {
	    staticClass: "form-control",
	    domProps: {
	      "value": _vm.activeNote.text
	    },
	    on: {
	      "input": _vm.updateNote
	    }
	  })])
	},staticRenderFns: []}

/***/ },

/***/ 120:
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _vm._m(0)
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticStyle: {
	      "margin-top": "6em"
	    },
	    attrs: {
	      "id": "firebaseui-auth-wrapper"
	    }
	  }, [_c('h1', {
	    staticStyle: {
	      "text-align": "center"
	    }
	  }, [_vm._v("Sign In")]), _vm._v(" "), _c('div', {
	    attrs: {
	      "id": "firebaseui-auth-container"
	    }
	  })])
	}]}

/***/ }

});


// WEBPACK FOOTER //
// static/js/app.a7ffbaed9a4bac91bb3c.js